module.exports = __webpack_public_path__ + "home.jpg?f9f12f88909ad8191e7a7b7f1e985157";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/home.jpg
// module id = 134
// module chunks = 0